import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getExamStart, resetExamLoading } from "../../redux/exam/reducer";
import {
  selectSingleExamLoading,
  selectOneExam,
} from "../../redux/exam/selectors";

const useSingleExamGet = ({ id }) => {
  const dispatch = useDispatch();
  const isLoadingExam = useSelector(selectSingleExamLoading);
  const exam = useSelector(selectOneExam);

  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);

  const fetchExam = useCallback(() => {
    dispatch(getExamStart(id));
  }, [dispatch, id]);

  const resetLoadingExam = () => {
    dispatch(resetExamLoading());
  };

  useEffect(() => {
    if (id) {
      fetchExam();
    }
  }, [id, fetchExam, fetch]);
  return {
    exam,
    isLoadingExam,
    resetLoadingExam,
    refetchExam: refetch,
  };
};

export default useSingleExamGet;
